import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';
import { Profession, Grade, Swimlane, Tag, TeamRoleDef } from '../types';

// Хуки для профессий
export const useProfessions = () => {
  return useQuery({
    queryKey: ['professions'],
    queryFn: async (): Promise<Profession[]> => {
      return await api('/professions');
    },
  });
};

// Хуки для грейдов
export const useGrades = () => {
  return useQuery({
    queryKey: ['grades'],
    queryFn: async (): Promise<Grade[]> => {
      return await api('/grades');
    },
  });
};

// Хуки для свимлейнов
export const useSwimlanes = () => {
  return useQuery({
    queryKey: ['swimlanes'],
    queryFn: async (): Promise<Swimlane[]> => {
      return await api('/swimlanes');
    },
  });
};

// Хуки для тегов
export const useTags = () => {
  return useQuery({
    queryKey: ['tags'],
    queryFn: async (): Promise<Tag[]> => {
      return await api('/tags');
    },
  });
};

// Роли в командах — справочник компании, читает любой сотрудник.
export const useTeamRoles = () => {
  return useQuery({
    queryKey: ['teamRoles'],
    queryFn: async (): Promise<TeamRoleDef[]> => api('/team-roles'),
    staleTime: 5 * 60 * 1000,
  });
};
